<template>
  <section class="form-container">
    <div class="form-card">
      <h1 class="form-title">{{ $t('forgotPassword.title') }}</h1>

      <form class="form-content" @submit.prevent="submit">
        <input
          v-model="email"
          type="email"
          :placeholder="$t('forgotPassword.placeholder')"
          required
        />

        <button type="submit" class="btn" :disabled="loading">
          {{ loading ? $t('forgotPassword.loading') : $t('forgotPassword.button') }}
        </button>

        <p v-if="message" class="success-msg">{{ message }}</p>
        <p v-if="error" class="error-msg">{{ error }}</p>
      </form>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      message: '',
      error: '',
      loading: false
    }
  },
 methods: {
  async submit() {
    this.message = ''
    this.error = ''
    this.loading = true

    try {
      const res = await axios.post('/auth/forgot-password', { email: this.email })
      this.message = res.data.message
    } catch (err) {
      this.error = err.response?.data?.message || this.$t('forgotPassword.error')
    } finally {
      this.loading = false
    }
  }
}
}
</script>

<style scoped>
.form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 120px);
  padding: 40px 20px 80px;
  box-sizing: border-box;
  background: transparent;
}

.form-card {
  background: rgba(255, 255, 255, 0.95);
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 440px;
}

.form-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.form-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

input[type='email'] {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
}

.btn {
  background-color: #0c2d57;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.btn:hover:enabled {
  background-color: #0a2444;
}

.success-msg {
  color: green;
  text-align: center;
  font-size: 0.9em;
}
.error-msg {
  color: red;
  text-align: center;
  font-size: 0.9em;
}

@media (max-width: 600px) {
  .form-card {
    padding: 20px;
    border-radius: 12px;
  }
  .form-title {
    font-size: 20px;
  }
  input[type='email'],
  .btn {
    font-size: 14px;
    padding: 10px;
  }
}
</style>
